import React from 'react';
import { Marker } from '@vis.gl/react-maplibre';
import { isValidLatLng } from '../../utils/geo';

type MarkerAnchor = 'center' | 'top' | 'bottom' | 'left' | 'right' | 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';

interface Props {
  position: unknown;
  color?: string;
  opacity?: number;
  title?: string;
  size?: number;
  className?: string;
  label?: React.ReactNode | null;
  anchor?: MarkerAnchor;
  onClick?: ((event: React.MouseEvent<HTMLButtonElement>) => void) | null;
}

export default function MapDotMarker({
  position,
  color = 'var(--color-primary)',
  opacity = 1,
  title = '',
  size = 16,
  className = '',
  label = null,
  anchor = 'center',
  onClick = null,
}: Props) {
  if (!isValidLatLng(position)) return null;

  const [latitude, longitude] = position as [number, number];
  const classes = ['map-dot-marker', className].filter(Boolean).join(' ');

  return (
    <Marker latitude={latitude} longitude={longitude} anchor={anchor}>
      <button
        type="button"
        className={classes}
        style={{
          '--map-dot-color': color,
          '--map-dot-opacity': opacity,
          '--map-dot-size': `${size}px`,
        } as React.CSSProperties}
        onClick={(event) => {
          event.stopPropagation();
          onClick?.(event);
        }}
        title={title}
        aria-label={title || String(label ?? '') || 'Map marker'}
      >
        {label != null && <span className="map-dot-marker__label">{label}</span>}
      </button>
    </Marker>
  );
}
